<template>
    <modal @close="$emit('close', false)" :show-title="true" :size="'medium'">
        <div slot="header">
            <h5 class="modal-title">{{this.headerTitle}}</h5>
        </div>
        <div slot="body">
            {{this.bodyText}}
        </div>
        <div slot="footer" class="flex-fill">
            <button type="button" class="btn btn-default float-left" @click="$emit('close', false)">
                {{$t('btn_annulla')}}
            </button>
            <button type="button" class="btn btn-primary float-right" @click="$emit('close',true)">
                {{$t('btn_conferma')}}
            </button>
        </div>
    </modal>
</template>

<script>
    import Modal from "./Modal";

    export default {
        name: "ModalConfirm",
        props: ['bodyText', 'headerTitle'],
        components: {
            Modal
        }
    }
</script>
